import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  downloadAlternateText: {
    id: 'views.Presentations.ListItem.download',
    defaultMessage: 'Pobierz'
  }
});



// WEBPACK FOOTER //
// ./src/views/Presentations/Components/PresentationListItem/PresentationListItem.intl.js